// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import { NewTier, type Tier, type TierWireFormat } from '../Tier/Tier';

export class CompanySummary {
  readonly id: string;
  readonly name: string;
  readonly alternateID: string | null;
  readonly category: Enums.CompanyCategory;
  readonly streetAddress: string | null;
  readonly city: string | null;
  readonly state: string;
  readonly markets: string | null;
  readonly tiers: Tier[];
  readonly tierNames: string | null;
  readonly isArchived: boolean;
  readonly userId: string | null;
  readonly userName: string | null;
  readonly isConnectedToDispatchCustomer: boolean;
  readonly creditStatusCode: string | null;
  readonly creditStatusDescription: string | null;
  readonly code: string | null;
  readonly hasExportableQuotes: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.alternateID = data.alternateID === undefined ? null : data.alternateID;
    this.category = data.category === undefined ? Enums.CompanyCategory.Contractor : data.category;
    this.streetAddress = data.streetAddress === undefined ? null : data.streetAddress;
    this.city = data.city === undefined ? null : data.city;
    this.state = data.state === undefined ? '' : data.state;
    this.markets = data.markets === undefined ? null : data.markets;
    this.tiers = (data.tiers ?? []).map((tiers: any) => NewTier(tiers));
    this.tierNames = data.tierNames === undefined ? null : data.tierNames;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.userId = data.userId === undefined ? null : data.userId;
    this.userName = data.userName === undefined ? null : data.userName;
    this.isConnectedToDispatchCustomer =
      data.isConnectedToDispatchCustomer === undefined ? false : data.isConnectedToDispatchCustomer;
    this.creditStatusCode = data.creditStatusCode === undefined ? null : data.creditStatusCode;
    this.creditStatusDescription =
      data.creditStatusDescription === undefined ? null : data.creditStatusDescription;
    this.code = data.code === undefined ? null : data.code;
    this.hasExportableQuotes =
      data.hasExportableQuotes === undefined ? false : data.hasExportableQuotes;
  }

  static zero(): CompanySummary {
    const zeroValues: ExcludeMethodsDeep<CompanySummary> = {
      id: NIL_UUID,
      name: '',
      alternateID: null,
      category: Enums.CompanyCategory.Contractor,
      streetAddress: null,
      city: null,
      state: '',
      markets: null,
      tiers: [],
      tierNames: null,
      isArchived: false,
      userId: null,
      userName: null,
      isConnectedToDispatchCustomer: false,
      creditStatusCode: null,
      creditStatusDescription: null,
      code: null,
      hasExportableQuotes: false,
    };
    return new CompanySummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CompanySummaryWireFormat = {
  id: string;
  name: string;
  alternateID: string | null;
  category: string;
  streetAddress: string | null;
  city: string | null;
  state: string;
  markets: string | null;
  tiers: TierWireFormat[];
  tierNames: string | null;
  isArchived: boolean;
  userId: string | null;
  userName: string | null;
  isConnectedToDispatchCustomer: boolean;
  creditStatusCode: string | null;
  creditStatusDescription: string | null;
  code: string | null;
  hasExportableQuotes: boolean;
};

type NewCompanySummaryProps = PartialDeep<CompanySummary, { recurseIntoArrays: true }>;
export const NewCompanySummary: (props: NewCompanySummaryProps) => CompanySummary = (props) =>
  new CompanySummary(props);

type NewCompanySummaryFromWireFormatProps = PartialDeep<
  CompanySummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCompanySummaryFromWireFormat: (
  props: NewCompanySummaryFromWireFormatProps,
) => CompanySummary = (props) => new CompanySummary(props);
